<template>
  <nav class="horizontal-navbar">
    <div class="navbar-top-row">
      <div class="navbar-logo">
        <router-link to="/">
          <img src="../assets/logo.png" alt="Franchise Brigade" />
        </router-link>
      </div>
      <div class="navbar-actions mobile-only">
        <router-link to="/list-franchise" class="navbar-btn">List Your Franchise</router-link>
      </div>
      <button class="navbar-hamburger" @click="isMenuOpen = !isMenuOpen" :aria-label="isMenuOpen ? 'Close menu' : 'Open menu'" :class="{ open: isMenuOpen }">
        <span :class="{ 'bar1': true, 'open': isMenuOpen }"></span>
        <span :class="{ 'bar2': true, 'open': isMenuOpen }"></span>
        <span :class="{ 'bar3': true, 'open': isMenuOpen }"></span>
      </button>
    </div>
    <ul class="navbar-links" :class="{ open: isMenuOpen }">
      <li><router-link to="/" exact>Home</router-link></li>
      <li><router-link to="/franchises">Franchises</router-link></li>
      <li><router-link to="/about">About</router-link></li>
      <li><router-link to="/blogs">Blog</router-link></li>
      <li><router-link to="/contactus">Contact</router-link></li>
    </ul>
    <div class="navbar-actions desktop-only">
      <router-link to="/list-franchise" class="navbar-btn">List Your Franchise</router-link>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
const isMenuOpen = ref(false)
</script>

<style scoped>
.horizontal-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 5px 32px 5px 24px; */
  padding: 5px 32px 3px 24px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(44,62,80,0.04);
  border-bottom: 1px solid #f0f0f0;
  font-family: inherit;
  font-size: inherit;
  position: relative;
  z-index: 10;
}
.navbar-logo img {
  height: 150px;
  width: auto;
  margin: -20px 5px;
  display: block;
}
.navbar-hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  margin-left: auto;
  position: relative;
  z-index: 20;
}
.navbar-hamburger span {
  display: block;
  width: 28px;
  height: 3px;
  margin: 5px 0;
  background: #222;
  border-radius: 2px;
  transition: all 0.3s;
  position: relative;
}
.navbar-hamburger.open .bar1 {
  transform: translateY(8px) rotate(45deg);
}
.navbar-hamburger.open .bar2 {
  opacity: 0;
}
.navbar-hamburger.open .bar3 {
  transform: translateY(-8px) rotate(-45deg);
}
.navbar-links,
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 36px;
  list-style: none;
  margin: 0;
  padding: 0;
  transition: none;
}
.navbar-links {
  display: flex;
  align-items: center;
  gap: 36px;
  list-style: none;
  margin: 0;
  padding: 0;
  transition: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.navbar-links li {
  font-size: 1.5rem;
  font-weight: 500;
}
.navbar-links a {
  color: #222;
  text-decoration: none;
  padding: 8px 18px;
  border-radius: 10px;
  transition: background 0.15s, color 0.15s;
  font-family: inherit;
  font-size: inherit;
}
.navbar-links a.active,
.navbar-links a.router-link-exact-active {
  /* background: #f3f6fd; */
  color: var(--primary-orange);
}
.navbar-links a:hover {
  background: #f3f6fd;
  color: var(--primary-blue);
}
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-left: auto;
}

.navbar-btn {
  background: var(--primary-blue, #3b4fff);
  color: #fff;
  font-weight: 700;
  font-size: 1.2rem;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  box-shadow: 0 2px 8px rgba(44,62,80,0.08);
  margin-left: 8px;
  font-family: inherit;
}
.navbar-btn:hover {
  background: #1d2e7a;
  color: #fff;
}
.navbar-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}
.desktop-only { display: flex; }
.mobile-only { display: none; }
@media (max-width: 900px) {
  .navbar-top-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
  }
  .horizontal-navbar {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 8px;
    position: relative;
  }
  .navbar-hamburger {
    display: flex;
    z-index: 20;
  }
  .navbar-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 8px 24px rgba(44,62,80,0.10);
    margin: 0;
    padding: 0 0 10px 0;
    flex-direction: column;
    width: 100%;
    opacity: 0;
    transform: translateY(-16px) scaleY(0.98);
    pointer-events: none;
    transition: opacity 0.35s cubic-bezier(0.4,0,0.2,1), transform 0.35s cubic-bezier(0.4,0,0.2,1);
    z-index: 15;
  }
  .navbar-links.open {
    opacity: 1;
    transform: translateY(0) scaleY(1);
    pointer-events: auto;
    transition: opacity 0.35s cubic-bezier(0.4,0,0.2,1), transform 0.35s cubic-bezier(0.4,0,0.2,1);
  }
  .navbar-links {
    gap: 18px;
    justify-content: center;
    margin: 10px 0;
  }
  .navbar-links li {
    font-size: 2rem;
    padding: 18px 0;
  }
  .navbar-links a {
    font-size: 2rem;
    padding: 18px 28px;
  }
  .navbar-actions {
    position: static;
    width: 100%;
    display: flex !important;
    justify-content: flex-end;
    margin-top: 10px;
    background: none;
    box-shadow: none;
    opacity: 1;
    transform: none;
    pointer-events: auto;
    transition: none;
    z-index: 30;
    gap: 10px;
  }
  .desktop-only { display: none !important; }
  .mobile-only { display: flex !important; width: 100%; justify-content: flex-end; margin-top: 10px; }
}
@media (max-width: 600px) {
  .horizontal-navbar {
    flex-direction: column;
    align-items: stretch;
    padding: 8px 2vw;
  }
  .navbar-logo img {
    height: 48px;
  }
  .navbar-links {
    gap: 8px;
    font-size: 1rem;
  }
  .navbar-actions {
    gap: 6px;
  }
  .navbar-btn {
    font-size: 1rem;
    padding: 7px 10px;
  }
}
</style> 